/* Happymami · Tienda — lógica de la página.
   Sin librerías. Todo va dentro de .hm-tienda para no chocar con el tema.
   - Filtros por categoría (Todo / Biberón / Packs / Accesorios / Tetina)
   - Color del biberón (cambia foto y fondo)
   - Color de termo, dosificador y muselinas + botón «+» que añade al carrito de Shopify
   - Opiniones de matronas que cambian solas cada 7 segundos                       */
(function () {
  var root = document.querySelector('.hm-tienda[data-assets]') || document.querySelector('.hm-tienda');
  if (!root) return;

  // Carpeta de imágenes. En Shopify la rellena la sección (asset_url); en la demo es "assets/".
  var A = root.getAttribute('data-assets') || 'assets/';

  var T = {};
  try { T = JSON.parse(document.getElementById('hm-tienda-i18n').textContent); } catch (e) {}
  function fill(str, o) { return String(str || '').replace('[name]', o.name || '').replace('[color]', o.color || ''); }

  function $$(sel, ctx) { return [].slice.call((ctx || root).querySelectorAll(sel)); }
  function only(group, btn, attr) { group.forEach(function (b) { b.setAttribute(attr || 'aria-pressed', b === btn ? 'true' : 'false'); }); }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // Pequeño «pop» al cambiar la foto de color.
  function swap(img) {
    if (reduce || !img) return;
    img.classList.remove('hm-swap'); void img.offsetWidth; img.classList.add('hm-swap');
  }

  /* ---------- 1. Filtros por categoría ---------- */
  var fBtns = $$('.hm-filter');
  var cats = $$('[data-cat]');
  fBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      only(fBtns, b);
      var f = b.getAttribute('data-f');
      cats.forEach(function (c) { c.hidden = !(f === 'todo' || c.getAttribute('data-cat') === f); });
      if (window.hmTiendaAfterFilter) window.hmTiendaAfterFilter();
    });
  });

  /* ---------- 2. Biberón: color ---------- */
  var halo = { violeta: '#BBB6C5', rosa: '#F5D6CF', menta: '#D1E1D7' };
  var bBtns = $$('[data-bib]');
  var bibImg = root.querySelector('#bib-img');
  var bibCard = root.querySelector('#bib-card');
  bBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      only(bBtns, b);
      var c = b.getAttribute('data-bib');
      bibImg.src = b.getAttribute('data-img') || (A + 'hm-biberon-' + c + '.webp');
      bibImg.alt = fill(T.bibAlt, { color: (T.colors || {})[c] || c });
      swap(bibImg);
      bibImg.parentNode.style.background = halo[c];
    });
  });

  /* ---------- 3. Accesorios: color + añadir al carrito ---------- */
  var file = { termo: 'hm-termo-', dosificador: 'hm-dosificador-', muselina: 'hm-muselina-' };
  var nombre = T.names || { termo: 'Termo', dosificador: 'Dosificador', muselina: 'Muselinas' };
  var toast = root.querySelector('#toast');
  var tt;

  function showToast(msg) {
    toast.textContent = msg;
    toast.hidden = false;
    toast.classList.remove('hm-pop'); void toast.offsetWidth; toast.classList.add('hm-pop');
    clearTimeout(tt);
    tt = setTimeout(function () { toast.hidden = true; }, 3500);
  }

  // Añade al carrito y abre el carrito lateral del tema (si existe); si no, solo avisa.
  function addToCart(variantId) {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var payload = { items: [{ id: Number(variantId), quantity: 1 }] };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      payload.sections = cart.getSectionsToRender().map(function (x) { return x.id; });
      payload.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }
    return fetch(base + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    }).then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); }).then(function (res) {
      if (window.publish && window.PUB_SUB_EVENTS) { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hm-tienda', cartData: res }); }
      var opened = false;
      try {
        if (cart && typeof cart.renderContents === 'function' && res.sections) {
          if (!res.key && res.items && res.items[0]) res.key = res.items[0].key;
          cart.renderContents(res);
          opened = true;
        }
      } catch (e) {}
      return opened;
    });
  }

  $$('[data-acc]').forEach(function (card) {
    var k = card.getAttribute('data-acc');
    var sw = $$('[data-c]', card);
    var img = card.querySelector('.img img');
    sw.forEach(function (b) {
      b.addEventListener('click', function () {
        only(sw, b);
        var pk = b.getAttribute('data-c') === 'pack';
        img.src = b.getAttribute('data-img') || (A + file[k] + (pk ? 'rosa' : b.getAttribute('data-c')) + '.webp');
        img.parentNode.classList.toggle('is-photo', b.getAttribute('data-photo') === '1');
        swap(img);
        var nm = card.querySelector('[data-acc-name]'), pr = card.querySelector('[data-acc-price]');
        if (nm && b.dataset.title) nm.textContent = b.dataset.title;
        if (nm && nm.dataset.accBase && b.dataset.variant) nm.href = nm.dataset.accBase + '?variant=' + b.dataset.variant;
        if (pr && b.dataset.price && pr.textContent !== b.dataset.price) {
          pr.classList.remove('hm-swap'); void pr.offsetWidth; pr.classList.add('hm-swap');
          pr.textContent = b.dataset.price;
        }
        img.alt = pk ? 'Happymami ' + (b.dataset.title || '') : fill(T.accAlt, { name: nombre[k], color: (T.colors || {})[b.getAttribute('data-c')] || b.getAttribute('aria-label') });
      });
    });
    // Si el color por defecto no tiene stock (su botón no se pinta), se marca el primero disponible.
    if (sw.length && !card.querySelector('[data-c][aria-pressed="true"]')) sw[0].click();
    (function () {
      var on0 = card.querySelector('[data-c][aria-pressed="true"]'), l0 = card.querySelector('[data-acc-name]');
      if (on0 && l0 && l0.dataset.accBase && on0.dataset.variant) l0.href = l0.dataset.accBase + '?variant=' + on0.dataset.variant;
    })();
    var add = card.querySelector('.hm-add');
    add.addEventListener('click', function () {
      var on = card.querySelector('[data-c][aria-pressed="true"]');
      var color = on.getAttribute('data-c');
      var variant = on.getAttribute('data-variant');
      var msg = fill(T.added, { name: on.getAttribute('data-title') || nombre[k], color: (T.colors || {})[color] || on.getAttribute('aria-label') || color });
      if (!variant) { showToast(msg); return; } // demo o producto sin conectar
      add.disabled = true;
      addToCart(variant).then(function (opened) {
        if (!opened) showToast(msg);
        // Aviso para que el tema actualice el contador / carrito lateral (si lo escucha)
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }).catch(function () {
        showToast(T.error || 'No se ha podido añadir.');
      }).then(function () { add.disabled = false; });
    });
  });

  /* ---------- 4. No estás sola: opiniones de matronas (cambian cada 7 s) ---------- */
  var sl = root.querySelector('#qslider');
  if (sl) {
    var tr = root.querySelector('#qtrack');
    var dots = $$('.hm-qdots button', sl);
    var i = 0, t;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function go(n) { i = (n + dots.length) % dots.length; tr.style.transform = 'translateX(-' + (i * 100) + '%)'; only(dots, dots[i]); }
    function start() { clearInterval(t); if (!reduce) t = setInterval(function () { go(i + 1); }, 7000); }
    function stop() { clearInterval(t); }
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); start(); }); });
    sl.addEventListener('mouseenter', stop); sl.addEventListener('mouseleave', start);
    sl.addEventListener('focusin', stop); sl.addEventListener('focusout', start);
    start();
  }

  /* ---------- 5. Botón fijo: se oculta al terminar la zona de productos ---------- */
  var stk = root.querySelector('.hm-sticky');
  if (stk) {
    var upd = function () { stk.classList.toggle('is-off', root.getBoundingClientRect().bottom < window.innerHeight * 0.6); };
    window.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }

  // Botón «+»: pulso al añadir.
  $$('.hm-add').forEach(function (b) {
    b.addEventListener('click', function () {
      if (reduce) return;
      b.classList.remove('ok'); void b.offsetWidth; b.classList.add('ok');
    });
  });

  /* ---------- 7. Filtros deslizables: con el dedo (nativo) y con el ratón (arrastrar) ---------- */
  (function () {
    var bar = root.querySelector('.hm-filters .hm-scroll');
    if (!bar) return;
    var down = false, moved = false, sx = 0, sl = 0;
    bar.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return; // el táctil ya desliza solo
      down = true; moved = false; sx = e.clientX; sl = bar.scrollLeft;
    });
    bar.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - sx;
      if (!moved && Math.abs(dx) > 5) { moved = true; bar.classList.add('is-grabbing'); try { bar.setPointerCapture(e.pointerId); } catch (err) {} }
      if (moved) bar.scrollLeft = sl - dx;
    });
    function end(e) {
      if (!down) return;
      down = false;
      bar.classList.remove('is-grabbing');
      try { bar.releasePointerCapture(e.pointerId); } catch (err) {}
    }
    bar.addEventListener('pointerup', end);
    bar.addEventListener('pointercancel', end);
    // Tras arrastrar no debe activarse el filtro sobre el que se suelta.
    bar.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    // La rueda del ratón desplaza en horizontal.
    bar.addEventListener('wheel', function (e) {
      if (bar.scrollWidth <= bar.clientWidth || Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      bar.scrollLeft += e.deltaY; e.preventDefault();
    }, { passive: false });
    // El degradado de «hay más» solo se ve mientras queda barra por la derecha.
    function edge() { bar.classList.toggle('at-end', bar.scrollLeft + bar.clientWidth >= bar.scrollWidth - 4); }
    bar.addEventListener('scroll', edge, { passive: true });
    window.addEventListener('resize', edge);
    edge();
    // El filtro elegido se centra en la barra.
    bar.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.hm-filter');
      if (b && b.scrollIntoView) b.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    });
  })();
})();
